import { executeGet, executePost } from '../http-utils';

export const endpointUrl = '/api/order/';

export const get = (authToken: string) => executeGet<models.BookingSubdomainOrderCollectionModel>(endpointUrl + 'get/?authToken=' + (authToken ? encodeURIComponent(authToken) : ''));
export const getUpdatePaymentInfo = (authToken: string) => executeGet<models.UpdatePaymentInfoModel>(endpointUrl + 'getUpdatePaymentInfo/?authToken=' + (authToken ? encodeURIComponent(authToken) : ''));
export const postUpdatePaymentInfo = (model: models.SubmitUpdatePaymentInfoModel) => executePost<models.PostUpdatePaymentInfoResult>(endpointUrl + 'postUpdatePaymentInfo/', model);
